<template>
    <section class="md-testimonial review-add">
        <h2 class="title">
            {{ title || $t('md-testimonial.writeRecommendation') }}
        </h2>
        <v-form ref="form" class="review-form" :onSuccess="submitSuccess">
            <div class="form-top">
                <!-- TODO:  Need to confirm the maximum input length  -->
                <v-input
                    class="review-message"
                    name="reviewContent"
                    :maxlength="200"
                    :required="true"
                    tag="textarea"
                    @error="handleError"
                    :placeholder="$t('md-testimonial.tellUsHowGreatOf')"
                />
                <div class="image-upload">
                    <div class="img-box needsclick" @click="uploadFile">
                        <img-box
                            v-if="cropperSrc"
                            class="upload-img"
                            :src="cropperSrc"
                        />
                        <img-box
                            v-else
                            class="empty-img"
                            src="//cdn.chime.me/image/fs01/agnentinfo/20180412/19/original_8564609562351670.png"
                        />
                    </div>
                    <input
                        @change="uploadImg"
                        class="upload-file"
                        type="file"
                        crop-ratio="1.75"
                        accept="image/jpeg, image/png"
                        style="display: none"
                        ref="uploadFile"
                    />
                </div>
            </div>
            <div class="form-bottom">
                <div class="rating">
                    <p class="rating-title">
                        {{ $t('md-testimonial.rating') }}
                    </p>
                    <review-score :score="score" @star="star"></review-score>
                </div>
                <input type="submit" :value="$t('send')" class="submit" />
            </div>
        </v-form>
        <crop-img
            @change="changeValue"
            ref="cropImage"
            v-model:show="show"
        ></crop-img>
        <p class="err-msg" v-if="errMsg">{{ errMsg }}</p>
    </section>
</template>

<script>
import util from '@/common/util';
import signLog from '@/components/sign-log';
import vInput from '@/components/v-input.vue';
import vForm from '@/components/v-form.vue';
import { mapState } from 'pinia';
import { useUserStore } from "@/store";
import cropImg from './crop-img.vue';
import reviewScore from './review-score.vue';

export default {
    emits: ['addReview'],
    name: 'review-add',
    props: ['title'],
    i18next: {
        ns: 'md-testimonial'
    },
    components: {
        reviewScore,
        cropImg,
        vInput,
        vForm
    },
    computed: {
        ...mapState(useUserStore, {
            user: store => store.user
        })
    },
    data: function() {
        return {
            score: 5,
            show: false,
            cropperSrc: '',
            errMsg: ''
        };
    },
    methods: {
        handleError(msg) {
            this.errMsg = msg;
            util.timeout({
                handler: () => {
                    this.errMsg = '';
                },
                delay: 3000,
                unique: true
            });
        },
        star(level) {
            this.score = level;
        },
        uploadFile() {
            this.$refs.uploadFile.click();
        },
        uploadImg(evt) {
            this.$refs.cropImage.changeImage(evt);
            this.$refs.uploadFile.value = null;
        },
        changeValue(val) {
            console.log('new img:', val);
            this.cropperSrc = val;
        },
        submitSuccess(data = {}) {
            // TODO:  Add attributes directly on the instance to prevent repeated submissions , not good practice
            if (this.submitDisabled) {
                return; 
            }
            this.submitDisabled = true;
            //TODO: Change the code from  ../../../components/leave-msg/leave-msg#54
            // TODO:  The processing logic of verifying login should be placed in the interceptor
            if (this.user) {
                this.addComment(this.formatComment(data), true);
            } else {
                //  Successful login triggers automatic submission
                signLog.register({
                    onsuccess: () => {
                        this.addComment(this.formatComment(data), true);
                    }
                });
                this.submitDisabled = false;
            }
        },
        addComment(data, isToast) {
            const query =
                'mutation save($comment: ReviewInput){ saveReview(comment: $comment) }';
            this.axiosIns
                .post('/api-graphql', {
                    query: query,
                    variables: {
                        comment: data
                    }
                })
                .then(res => {
                    // TODO: @chengle  The back-end data contains another layer that needs to be parsed out and used here to avoid regression errors directly
                    let saveId;
                    if (res.data.saveTestimonial) {
                        saveId = JSON.parse(res.data.saveTestimonial).data.id; //;
                    }
                    this.$emit('addReview', saveId); //  This action is triggered after adding a comment
                    this.reset();
                    isToast &&
                        util.toast(
                            this.$t('md-testimonial.thankYouYourReview'),
                            1000
                        );
                })
                .catch(() => {
                    isToast &&
                        util.toast(this.$t('md-testimonial.submittedFailed'));
                })
                .finally(() => {
                    this.submitDisabled = false;
                });
        },
        formatComment(data) {
            data.reviewerName = this.user.fullName;
            data.reviewRate = this.score || 0;
            if (this.cropperSrc) {
                data.avatarLink = this.cropperSrc;
            }
            return data;
        },
        reset() {
            this.cropperSrc = '';
            this.score = 5;
            this.$refs.form.reset({
                reviewContent: ''
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.md-testimonial.review-add {
    width: 100%;
    .title {
        font-size: 24px;
        line-height: 29px;
        color: #010102;
    }
    .review-form {
        width: 100%;
        margin-top: 12px;
        .form-top {
            width: 100%;
            height: 152px;
            padding: 11px 10px;
            background-color: #f7f7f7;
            box-shadow: inset 0 0 4px 0 hsla(0, 0%, 79%, 0.8);
            display: flex;
            .review-message {
                width: 100%;
                // TODO:  Fix the text occlusion problem when checking the form
                .mg-error {
                    display: none;
                }
                //fix AM-259408
                .input-container {
                    height: 100%;
                }
                textarea {
                    height: 100%;
                    width: 100%;
                    flex: 1;
                    font-size: 15px;
                    padding: 4px 5px;
                    box-shadow: none;
                    border: none;
                    background-color: transparent;
                    &::placeholder {
                        font-size: 16px;
                        line-height: 1.25;
                        color: #a0a0a0;
                    }
                }
            }

            .image-upload {
                width: 227px;
                height: 100%;
                flex: none;
                border-radius: 1px;
                border: 6px solid #fff;
                background-color: #f7f7f7;
                box-shadow: 0 0 2px 0 hsla(0, 0%, 76%, 0.5);
                overflow: hidden;
                .img-box {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    .empty-img {
                        width: 84px;
                        height: 74px;
                    }
                    .upload-img {
                        width: 100%;
                    }
                    .img-content > img {
                        object-fit: contain;
                    }
                }
            }
        }
        .form-bottom {
            width: 100%;
            height: 40px;
            display: flex;
            -ms-flex-pack: justify;
            justify-content: space-between;
            border: 1px solid rgba(80, 80, 80, 0.2);
            .rating {
                display: flex;
                padding-left: 12px;
                .rating-title {
                    font-size: 16px;
                    color: #c9c9c9;
                    line-height: 40px;
                }
            }
            .submit {
                width: 101px;
                height: 100%;
                @include color-button();
                font-size: 15px;
                font-family: var(--font-bold);
            }
        }
    }
    .err-msg {
        font-size: 12px;
        color: #f76363;
    }
}
</style>
